import { CommonGet, CommonPost, CommonGetIDServer } from "../../../utils/CommonFetch";

export default {
    getGroups,
    getEstatesByGroupID,
    getAllAdvancedRequestByFilter,
    updateAdvancedRequest,
    getAdvancedRequestDetails,
    getCollectionPointsByOperationentityGroupID,
    AdvancedRequestApprovalStatusUpdate,
    AdvancedRequestRejectStatusUpdate
};


async function getCollectionPointsByOperationentityGroupID(groupID, operationEntityID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if(item[1]["operationEntityID"] === parseInt(operationEntityID) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
                collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function getEstatesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupId=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {
        
            array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return array;
}

async function getGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function updateAdvancedRequest(advancedRequest) {
    const response = await CommonPost('/api/AdvancedRequest/updateAdvancedRequest', null, advancedRequest);
    return response;
}

async function getAdvancedRequestDetails(advancedRequestId) {
    const response = await CommonGet('/api/AdvancedRequest/getAdvancedRequestDetails', `advancedRequestId=${advancedRequestId}`);
    return response;
}

async function getAllAdvancedRequestByFilter(operationEntityID, collectionPointID, fromDate,toDate,statusID) {
    var newModel = {
        operationEntityID: parseInt(operationEntityID),
        collectionPointID: parseInt(collectionPointID),
        fromDate: fromDate,
        toDate: toDate,
        statusID: parseInt(statusID)
    }
    const response = await CommonPost('/api/AdvancedRequest/getAllAdvancedRequestByFilter', null, newModel);
    return response.data;
}

async function AdvancedRequestApprovalStatusUpdate(advancedRequestID,approvedAmount,reason) {
    var newModel = {
        advancedRequestID: parseInt(advancedRequestID),
        approvedAmount: parseFloat(approvedAmount),
        reason: reason
    }
    const response = await CommonPost('/api/AdvancedRequest/updateAdvancedRequestApproval', null, newModel);
    return response;
}

async function AdvancedRequestRejectStatusUpdate(advancedRequestID,approvedAmount,reason) {
    var newModel = {
        advancedRequestID: parseInt(advancedRequestID),
        approvedAmount: parseFloat(approvedAmount),
        reason: reason
    }
    const response = await CommonPost('/api/AdvancedRequest/UpdateAdvancedRequestReject', null, newModel);
    return response;
}
